let counter = 0;

function s4(): string {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
}

/**
 * Angular-compatible GUID generator.
 */
export function generateGuid(): string {
  return (
    s4() +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    s4() +
    s4()
  );
}

/**
 * Generate a unique id for all graph entities.
 * Kept as a single generator entry-point for compatibility with existing callers.
 */
export function generateId(prefix: string): string {
  void prefix;
  counter += 1;
  return generateGuid();
}

/** Reset the counter — for test cleanup only. */
export function _resetIdCounter(): void {
  counter = 0;
}
